<template>
  <NuxtLayout name="default" :show-back-button="false">
    <SofaxBreadcrumb :title="t('seo.privacy.title')" :items="[{ name: t('seo.privacy.title') }]" />

    <section class="sofax bg-white dark:bg-gray-950">
      <div class="section-space">
        <div class="shell">
          <SofaxLegalDocument :document="legalDocument" />
        </div>
      </div>
      <div class="separator" />
    </section>

    <SofaxPageCta />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { privacyPolicy } from '~/constants/legal/privacy'
import { privacyPolicyCs } from '~/constants/legal/privacyCs'
import { privacyPolicyDe } from '~/constants/legal/privacyDe'
import { privacyPolicyPl } from '~/constants/legal/privacyPl'

const { t, locale } = useI18n()

/*
 * `layout: false` + explicit NuxtLayout so the default layout's back button
 * can be switched off; definePageMeta cannot pass layout props.
 */
definePageMeta({
  layout: false,
})

// Its URL in Czech, German and Polish (constants/localizedRoutes.ts).
false && /*#__PURE__*/ defineI18nRoute({ paths: { cs: '/ochrana-osobnich-udaju', de: '/datenschutz', pl: '/polityka-prywatnosci' } })

const legalDocument = computed(() => (locale.value === 'cs' ? privacyPolicyCs() : locale.value === 'de' ? privacyPolicyDe() : locale.value === 'pl' ? privacyPolicyPl() : privacyPolicy()))

// SEO Meta
useSeoMeta({
  title: () => t('seo.privacy.title'),
  description: () => t('seo.privacy.description'),
  ogTitle: () => t('seo.privacy.title'),
  ogDescription: () => t('seo.privacy.description'),
})
</script>
